var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.521 281.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-information-circle-outline",
    "data-name": "Icon ionic-ios-information-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_924",
    "data-name": "Trazado 924",
    d: "M16.552,24.176A13.55,13.55,0,0,1,30.425,10.709c7.715,0,14.008,5.752,14.008,13.467S38.139,37.71,30.425,37.71A13.606,13.606,0,0,1,16.552,24.176ZM17.5,48.335H43.35v97.517H17.5Z",
    transform: "translate(113.643 63.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_925",
    "data-name": "Trazado 925",
    d: "M144.135,22.324a121.832,121.832,0,0,1,86.148,207.96,121.832,121.832,0,0,1-172.3-172.3,121.006,121.006,0,0,1,86.148-35.664m0-18.949A140.76,140.76,0,1,0,284.9,144.135,140.739,140.739,0,0,0,144.135,3.375Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation_mark.6c6f079f90c744a4cdd5c35fcce008ad.svg";
export { ForwardRef as ReactComponent };